import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

export type ConfirmationDialogButtonColor =
  | "primary"
  | "secondary"
  | "success"
  | "error"
  | "info"
  | "warning";

export interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  buttonColor?: ConfirmationDialogButtonColor;
  confirmButtonText?: string;
}

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  buttonColor = "error",
  confirmButtonText = "confirmation_dialog.confirm"
}: ConfirmationDialogProps) => {
  const { t } = useTranslation();
  const dialogId = `${title}-dialog-title`;
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby={dialogId}>
      <DialogTitle id={dialogId}>{title}</DialogTitle>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {t("navbar.logout.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          autoFocus
          variant="contained"
          color={buttonColor}
        >
          {t(confirmButtonText)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
